import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'components/shared/Button';
import styles from './NotFound.module.scss';

function NotFound() {
  const navigate = useNavigate()
  return (
    <div className={styles.container}>
      <div className={styles.panel}>
        <Button link onClick={() => navigate('/')}>
          Not found
        </Button>
      </div>
    </div>
  )
}

export default NotFound
